import Select from 'components/Common/Form/Input/Select'
import TextInput from 'components/Common/Form/Input/TextInput'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'

function ContentfulFormField(props: Omit<App.ComponentFormField, 'contentTypeId'>) {
  const intl = useIntl()
  const { type, label, placeholder, isRequired, options } = props

  const optionsErrorText = intl.formatMessage({
    id: 'vRBpd47bl34rlxn-ZCNj',
    defaultMessage: 'Error: `options` is required.',
    description: 'Error message shown when select form field is missing options',
  })
  const notSupportedText = intl.formatMessage({
    id: 'dwdoFvcXGRJ6iepLzUJB',
    defaultMessage: 'Not Supported Form Field',
    description: 'Error message shown when an unsupported form field type is encountered',
  })

  const renderField = () => {
    switch (type) {
      case 'email':
        return <TextInput type="email" placeholder={placeholder} label={label} name={label} required={isRequired} />
      case 'text':
        return <TextInput type="text" placeholder={placeholder} label={label} name={label} required={isRequired} />
      case 'checkbox':
        return <Group direction="horizontal" verticalAlign="center">
          <CheckboxInput required={isRequired} name={label}> {label}</CheckboxInput>
        </Group>
      case 'select':
        if (!options) return <div>{optionsErrorText}</div>
        return (
          <Select label={label} required={isRequired} name={label}>
            {options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </Select>
        )
      default:
        return <div>{notSupportedText}</div>
    }
  }

  return (
    <>
      {renderField()}
    </>
  )
}

export default ContentfulFormField
